import React from "react";

import basePath from "../utils/basePath";
// import Checkbox from "./Checkbox";
// import { Form } from "react-bootstrap";

class FamilyName extends React.Component {
  state = { familyname: "Millennium", disclaimer: false, validated: false };
  // handleInput = (event) => {
  //   this.setState({ [event.target.name]: event.target.value });
  // };
  // handleSubmit = (event) => {
  //   const form = event.currentTarget;
  //   if (form.checkValidity() === false) {
  //     document.querySelector("input:invalid").focus();
  //     this.setState({ validated: true });
  //   } else {
  //     this.props.updateFamilyName(this.state.familyname);
  //     this.props.goTo("BuildAvatar");
  //   }
  //   event.preventDefault();
  // };
  render() {
    return (
      <div className="family-name">
        <section className="white">
          <div className="container">
            <div className="row no-gutters wrapper">
              <div className="col-12 base-bg">
                <img src={`${basePath}images/avatar-home.svg`} className="desktop-only" />
                <img src={`${basePath}images/avatar-home-mobile.svg`} className="mobile-only" />
                <div className="text-wrapper">
                  <h1 className="title light">
                    <span className="leftblock">
                      HOW
                      <br />
                      DID
                      <br />
                      YOU
                    </span> 
                    <span className="rightblock">
                      <em>20</em>
                      <br />
                      <em>20</em>
                    </span>
                    <span className="question">?</span>
                  </h1>
                  <p className="description desktop-only">We all did it differently! Create your very own 2020 avatar and share it with your friends.</p>
                </div>
              </div>

              <div className="col-md-10 offset-md-1 button-wrapper">
                <p className="description mobile-only">We all did it differently! Create your very own 2020 avatar and share it with your friends.</p>
                <button type="button" className="btn btn-primary" onClick={() => this.props.goTo("BuildAvatar")}>get started</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default FamilyName;
